// @flow
import { connect } from "react-redux";
import PhotoDialog from "./view";
import PhotoCard from "./photo-card";
import Dialog from "../dialog";
import { hidePhoto } from "../state/blogs/actions";
import { getShowPhoto } from "../state/blogs/reducer";

export default connect(
    state => ({
        photo: getShowPhoto(state.blogs),
        PhotoCard,
        Dialog
    }),
    dispatch => ({
        onHidePhoto: () => dispatch(hidePhoto())
    })
)(PhotoDialog);



// WEBPACK FOOTER //
// ./src/photo-dialog/index.js